<template>
  
    <section id="about" class="pb-0 about">
        <div class="about-chat">
            <div class="container ">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <div class="section-title">
                            <h2> حول حلقة الدردشة </h2>
                            <img src="../../assets/images/title-line.png" alt="title-line" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-md-12 about-box">
                        <div class="row">
                            <div class="col-lg-3 col-sm-6 about-border">
                                <div class="chat-box">
                                    <img src="../../assets/images/stay-connected.png" alt="stay-connected">
                                    <h3 class="sub-title">ابق على اتصال</h3>
                                </div>
                            </div>
                            <div class="col-lg-3 col-sm-6 about-border">
                                <div class="chat-box">
                                    <img src="../../assets/images/get-notified.png" alt="get-notified">
                                    <h3 class="sub-title"> الحصول على إخطار </h3>
                                </div>
                            </div>
                            <div class="col-lg-3 col-sm-6 about-border">
                                <div class="chat-box">
                                    <img src="../../assets/images/stay-updated.png" alt="stay-updated">
                                    <h3 class="sub-title">تبقى محدثة</h3>
                                </div>
                            </div>
                            <div class="col-lg-3 col-sm-6">
                                <div class="chat-box">
                                    <img src="../../assets/images/mini-world.png" alt="mini-world">
                                    <h3 class="sub-title">عالم صغير</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="chat-slide">
                            <h3>تواصل مع الأشخاص في جميع أنحاء العالم باستخدام جهازك الصغير</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid text-center">
            <img src="../../assets/images/banner.png" alt="banner.png" class="img-fluid full-banner">
        </div>
    </section>
  
</template>
<script>
export default {
  name: 'About'
}
</script>
